<template>
  <div class="card-dashboard-custom">
    <p class="card-title">{{ title }}</p>
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "card-dashboard",
  props: {
    title: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
.card-dashboard-custom {
  background: #fff;
  margin: 15px 0;
  padding: 15px;
  border-radius: 10px;
  width: 100%;

  .card-title {
    color: #11263c;
    font-size: 18px;
    font-weight: 400;
  }
}
</style>

<style lang="scss">
.progress {
  margin: 10px 0;
  height: 10px;
  overflow: hidden;
  background: #e3def7;
  border-radius: 10px;
  width: 100%;

  .bar {
    float: left;
    height: 100%;
    background: #7459d9;
    border-radius: inherit;
  }
}

button.slick-prev:before,
button.slick-next:before {
  color: #197bbd;
  font-size: 26px;
}
</style>
